import gfaAdult from 'images/brands/gfa/avatars/adult.png';
import gfaMinor from 'images/brands/gfa/avatars/minor.png';
import gfaOldAdult from 'images/brands/gfa/avatars/old-adult.png';
import gfaStudent from 'images/brands/gfa/avatars/student.png';
import gfaTeacher from 'images/brands/gfa/avatars/teacher.png';
import gfaPcd from 'images/brands/gfa/avatars/pcd.png';

/**
 * Passenger artwork for the redesigned exchange ticket cards, by the category the backend sends.
 *
 * The GFA illustrations are the app's shared default for passenger categories — `passengerTypes`
 * already uses them everywhere a category needs a face — so the exchange follows the same
 * convention rather than inventing a second one. A brand with its own set overrides them there.
 */
const CATEGORY_AVATARS = {
  adult: gfaAdult,
  general: gfaAdult,
  child: gfaMinor,
  minor: gfaMinor,
  minor_simple: gfaMinor,
  infant: gfaMinor,
  older: gfaOldAdult,
  older_half: gfaOldAdult,
  student: gfaStudent,
  teacher: gfaTeacher,
  disability: gfaPcd,
  disability_half: gfaPcd,
  wheelchair_handicap: gfaPcd,
};

/**
 * Resolves a ticket to its passenger artwork.
 *
 * Kept outside the card so the card holds no brand assets, and shared by every exchange screen so
 * the same traveller is drawn the same way from the ticket list through to the schedule.
 *
 * @param {object} ticket - Ticket as the exchange store holds it.
 * @param {string} [ticket.category] - Passenger category the backend assigned.
 * @returns {string} The artwork's URL; the adult illustration for an unknown category.
 */
const avatarForTicket = (ticket) => CATEGORY_AVATARS[ticket?.category] || gfaAdult;

export default avatarForTicket;
export { CATEGORY_AVATARS };
